import { API } from "@/services/apiClient";

const KEY = "deuces_admin_key";
export const getKey = () => sessionStorage.getItem(KEY) || "";
export const setKey = (k) => sessionStorage.setItem(KEY, k);
export const clearKey = () => sessionStorage.removeItem(KEY);

// Thrown when the Apps Script CRM isn't deployed/reachable yet.
export class CrmOffline extends Error {}

async function req(path, options = {}) {
  const r = await fetch(`${API}${path}`, {
    ...options,
    headers: { "Content-Type": "application/json", "X-Admin-Key": getKey(), ...(options.headers || {}) },
  });
  if (r.status === 401) {
    clearKey();
    window.location.reload();
    throw new Error("UNAUTHORIZED");
  }
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    if (r.status === 502 || r.status === 503) throw new CrmOffline(data.detail || "CRM offline");
    throw new Error(data.detail || "Request failed");
  }
  return data;
}

export const checkKey = async (key) => {
  try {
    const r = await fetch(`${API}/admin/health`, { headers: { "X-Admin-Key": key } });
    return r.ok;
  } catch {
    return false;
  }
};

// Website lead inbox (MongoDB backup store)
export const getMongoLeads = () => req("/leads");

// Read-only CRM actions are idempotent — safe to auto-retry once after a
// cold-start timeout (Apps Script's first call after idle can exceed 30s).
const READONLY = new Set(["health", "getDashboard", "listLeads", "listCustomers", "getCustomer", "listEstimates", "listJobs", "listPayments", "listFollowUps", "listWarranties", "listPhotos", "search"]);
const sleep = (ms) => new Promise(r => setTimeout(r, ms));

async function crmOnce(action, data) {
  const r = await req("/crm", { method: "POST", body: JSON.stringify({ action, data }) });
  if (r.ok === false) throw new CrmOffline(r.error || "CRM offline");
  return r.result;
}

export const crm = async (action, data = {}) => {
  try {
    return await crmOnce(action, data);
  } catch (e) {
    if (e instanceof CrmOffline && READONLY.has(action)) {
      await sleep(3000); // let the cold script warm up, then retry once
      return crmOnce(action, data);
    }
    throw e;
  }
};
